(function ($) {
  'use strict';

  $('.js-scroll-to').click(function (e) {

    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

    if (target.length) {
      e.preventDefault();

      $('html, body').animate({
        scrollTop: target.offset().top
      }, 600, function () {

      });
    }

  });

})(jQuery);
